import { useEffect, useState } from "react";
import { ConfirmationDialog } from "../../../ui/components/ConfirmationDialog";
import { useChangeRiskOrStatusWithRisk } from "../../hooks/useChangeRiskOrStatusWithRisk";
import { RiskLevelForm } from "../RiskLevelForm";

export type Props = {
  onClose: (reason: "changeRiskLevel" | "cancel") => void;
  open: boolean;
  riskLevel: string;
  riskLevelReason: string;
  verificationId: string;
  request: () => void;
};

export const ChangeRiskLevelDialog = (props: Props) => {
  const { onClose, open, verificationId, riskLevel, riskLevelReason } = props;

  const [newRiskLevel, setNewRiskLevel] = useState("");
  const [newRiskLevelReason, setNewRiskLevelReason] = useState("");
  const [changeRiskLevel, loading, error, result] =
    useChangeRiskOrStatusWithRisk(
      verificationId,
      newRiskLevel,
      newRiskLevelReason,
      undefined,
      undefined,
      {
        riskLevel,
        riskLevelReason,
      }
    );

  const handleClose = () => {
    onClose("cancel");
  };

  useEffect(() => {
    if (open) {
      setNewRiskLevel(riskLevel);
      setNewRiskLevelReason(riskLevelReason);
    }
  }, [riskLevelReason, riskLevel, open]);

  useEffect(() => {
    if (result) {
      onClose("changeRiskLevel");
    }
  }, [result, onClose]);

  return (
    <ConfirmationDialog
      title='Risk Level'
      error={error}
      confirmText='Save'
      confirmAction={changeRiskLevel}
      disabled={loading}
      onClose={handleClose}
      isOpen={open}
      confirmButtonColor='primary'
    >
      <RiskLevelForm
        riskLevel={newRiskLevel}
        riskLevelReason={newRiskLevelReason}
        setRiskLevel={setNewRiskLevel}
        setRiskLevelReason={setNewRiskLevelReason}
      />
    </ConfirmationDialog>
  );
};
